import { Image } from 'antd';
import { FC, ReactNode, useState } from 'react';
import { CarouselRef } from 'antd/es/carousel';
import { StyledCarousel } from './ImagePreviewCarousel.styles';
import { ImagePreviewGroup } from '../ImagePreviewGroup';

type Props = {
  className?: string;
  size?: 'small' | 'medium';
  selectedIndex: number;
  onSelectedIndexChange: (index: number) => void;
  title?: ReactNode;
  images: {
    id: string;
    url: string;
    name: string;
  }[];
  carouselRef?: React.RefObject<CarouselRef>;
  currentPreviewIndex: number;
  setCurrentPreviewIndex: (index: number) => void;
};

export const ImagePreviewCarousel: FC<Props> = ({
  className,
  size = 'medium',
  selectedIndex,
  title,
  images,
  onSelectedIndexChange,
  carouselRef,
  currentPreviewIndex,
  setCurrentPreviewIndex
}) => {
  const [visible, setVisible] = useState(false);

  const currentPreviewName = images[currentPreviewIndex]?.name;

  const handleVisibleChange = (visible: boolean) => {
    setCurrentPreviewIndex(visible ? selectedIndex : 0);
    setVisible(visible);
  }

  const handleSelectedIndexChange = (_current: number, next: number) => onSelectedIndexChange(next);

  return (
    <ImagePreviewGroup
      total={images.length}
      currentPreviewName={currentPreviewName}
      preview={{
        title,
        onChange: setCurrentPreviewIndex,
        current: currentPreviewIndex,
        visible,
        onVisibleChange: handleVisibleChange,
      }}
    >
      <StyledCarousel
        className={`image-gallery image-gallery-${size} ${className}`}
        arrows
        infinite={false}
        dots={false}
        beforeChange={handleSelectedIndexChange}
        ref={carouselRef}
      >
        {images.map(image => (
          <Image key={image.id} src={image.url} />
        ))}
      </StyledCarousel>
    </ImagePreviewGroup>
  );
};
